import { useIntl } from "react-intl";
import { useParams } from 'react-router-dom';
// import { useState, useEffect } from 'react';
// import {toAbsoluteUrl} from '../../../_metronic/helpers';
// import { Modal, Button } from 'react-bootstrap';
import { PageTitle } from "../../../_metronic/layout/core";
import TabComponent from "../../common/components/TabComponent";
import AccesInternet from "../marketplace/AccesInternet";
import Telephonie from "../marketplace/Telephonie";
import Hebergement from "../marketplace/Hebergement";
import Styles from './Marketplace.module.scss';

interface MarketplaceProps {
  activeKey: string;
}

const Marketplace = ({ activeKey }: MarketplaceProps): JSX.Element => {
  const intl = useIntl();
  const { categoryId } = useParams<{ categoryId?: string }>();
  // const [showPopup, setShowPopup] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowPopup(false);
  //   }, 300000); 

  //   return () => clearTimeout(timer); // clear timer on unmount
  // }, []);
  // const handleClose = () => setShowPopup(false);
  // const handleContinue = () => {
  //   window.location.href = 'https://celeste.fr';
  // };


  return (
    <>
      <div className={Styles.marketplaceContainer}>
        <PageTitle breadcrumbs={[]}>
          {intl.formatMessage({id: 'MENU.MARKETPLACE'})}
        </PageTitle>
      </div>

      <div className="bg-light-primary border border-primary border-dashed rounded p-4 mb-5">
        <div className="d-flex align-items-center">
          <i className="fa-solid fa-cart-shopping fs-2x text-primary me-3"></i>
          <p className="text-gray-700 fs-6 mb-0">
            {intl.formatMessage({id: 'MARKETPLACE.INTRO'})}
          </p>
        </div>
      </div>


      <TabComponent
        tabData={[
          {
            title: intl.formatMessage({id: 'MARKETPLACE.CAT.INTERNET'}),
            key: 'acces',
            to: '/marketplace/acces',
            content: <AccesInternet />,
          },
          {
            title: intl.formatMessage({id: 'MARKETPLACE.CAT.TELEPHONY'}),
            key: 'telephonie',
            to: '/marketplace/telephonie',
            content: <Telephonie />,
          },
          {
            title: intl.formatMessage({id: 'MARKETPLACE.CAT.HOSTING'}),
            key: 'hebergement',
            to: '/marketplace/hebergement',
            content: <Hebergement categoryId={categoryId} />,
          },
        ]}
        activeKey={activeKey}
      />
    </>
  );
};

export default Marketplace;
